import { FC } from 'react';
import { FaqListItemResponseDto } from '@/features/faq/types/faq-dto';
import Archive_02_Icon from '@/components/icons/Archive_02_Icon';
import EPopupAccordion from '@/components/everridge/popup/EPopupAccordion';
import AddIcon from '@/components/icons/AddIcon';
import { t } from 'i18next';
import { cn } from '@/lib/utils';

type Props = {
	isMobile?: boolean;
} & FaqListItemResponseDto;

const FaqOwnerCard: FC<Props> = ({
	iconName,
	question,
	answer,
	linkUrl,
	isMobile,
}) => {
	const iconUrl = iconName?.split('-')[1] ?? '';

	const answerBlock = (
		<div
			className={cn('pl-9 select-none text-base', isMobile && 'text-sm')}>
			<span className='text-popover-800 break-all'>{answer}</span>
			{linkUrl && (
				<>
					&nbsp;&nbsp;
					<a
						href={linkUrl}
						target='_blank'>
						<span className='font-medium'>
							{t('main.faq.components.card.learnMore')}
						</span>
					</a>
				</>
			)}
		</div>
	);

	return (
		<div
			className={cn(
				'p-6 flex items-center gap-4 bg-popover-10 border border-popover-100 rounded-2.5xl',
				isMobile && 'p-4',
			)}>
			<EPopupAccordion
				icon={iconUrl}
				label={question ?? ''}
				content={answerBlock}
				containerClassName={cn('gap-4 text-lg', isMobile && 'text-sm')}
				contentClassName='mt-2'
				triggerIcon={AddIcon}
				triggerClassName='[&[data-state=open]>svg]:-rotate-135'
			/>
		</div>
	);
};

export default FaqOwnerCard;
